import {Box} from "@mui/system";
import AppRouter from "./AppRouter";
import React, {useEffect, useState} from "react";
import {authorization} from "../Constants";
import OrganizationCustomerService from "../API/orders/orders/organization/OrganizationCustomerService";
import OrganizationsStageSettingsService from "../API/organization/OrganizationsStageSettingsService";
import {determineAccessibility} from "./UI/navbar/determineAccessibility";
import {isKuhniVersoMebelDomain} from "../utils/isKuhniVersoMebelDomain";
import {EditLocalStoragePagesData} from "../utils/EditLocalStoragePagesData";
import {ToolbarFirst} from "./UI/navbar/ToolbarFirst";
import {ToolbarSecond} from "./UI/navbar/ToolbarSecond";
import {ScrollToTop} from "../utils/ScrollToTop";
import {useLocation, useNavigate} from "react-router-dom";
import {buildCurrentPath, consumeAuthReturnPath, saveAuthReturnPath} from "../utils/authReturnPath";
import {isPublicPath} from "../utils/publicPaths";
import {clearSession, logoutAndGoHome, redirectToSiteHome} from "../utils/siteHome";

const ContainerComponent = () => {
    const profileStorage = JSON.parse(localStorage.getItem("profile"))
    const auth = authorization + '/oauth2/authorization/' + window.location.host + '-authorization-code';
    const [profile, setProfile] = useState(profileStorage)
    const isOrgOne = !!profile?.userRoles?.find(el => el.name === "ROLE_ONE_ORGANIZATION_USER")
    const [isUpMeDomain, setIsUpMeDomain] = useState(false)
    const [domainName, setDomainName] = useState("")
    const [accessibility, setAccessibility] = useState({})
    const [stage, setStage] = useState(null)
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const currentDomain = window.location.hostname;
        const isUpMeDomain = ["t.upme.by", "upme.by"].includes(currentDomain)
        localStorage.setItem("isUpMeDomain", JSON.stringify(isUpMeDomain))
        setIsUpMeDomain(isUpMeDomain)
        setDomainName(currentDomain)
        OrganizationCustomerService.profile().then(function (response) {
            const returnPath = consumeAuthReturnPath();
            if (response.data?.userName === "AnonymousUser") {
                clearSession()
                setProfile(null)
                if (!isPublicPath(location.pathname)) {
                    redirectToSiteHome();
                    return response.data;
                }
                return response.data;
            }
            const isOrgOne = !!response.data?.userRoles?.find(el => el.name === "ROLE_ONE_ORGANIZATION_USER")
            response.data?.userRoles && handleAuth(response.data, isUpMeDomain, isOrgOne)
            if (returnPath && buildCurrentPath() !== returnPath) {
                navigate(returnPath, {replace: true});
            }
            return response.data
        }).then((data) => {
            const isOrganization = data?.userRoles && data.userRoles.some(role => ['ROLE_ORGANIZATION_USER_SETTINGS', 'ROLE_ORGANIZATION_USER', 'ROLE_ORGANIZATION_USER', 'ORGANIZATION_USER_MATERIAL_SUPER_USER', "ROLE_ORGANIZATION_SUPER_USER"].includes(role.name))
            isOrganization ? OrganizationsStageSettingsService.get().then(function (response) {
                setStage(response.data.stage)
                localStorage.setItem("stage", JSON.stringify(response.data.stage))
            }) : setStage(0)
        }).catch(handleError);

    }, []);

    const handleAuth = (data, isUpMeDomain, isOrgOne) => {
        localStorage.setItem("profile", JSON.stringify(data))
        setProfile(data)
        setAccessibility(() => determineAccessibility(
            data.userRoles,
            isUpMeDomain && !isOrgOne,
            isKuhniVersoMebelDomain(),
        ))
    }

    const handleError = () => {
        clearSession()
        setProfile(null)
        setStage(null)
        setAccessibility([])
        if (!isPublicPath(location.pathname)) {
            redirectToSiteHome();
        }
    }

    const handleChange = (menu) => {
        if (profile) {
            logoutAndGoHome();
        } else if (menu) {
            saveAuthReturnPath();
            window.location.href = auth
            EditLocalStoragePagesData("/settings", "expanded", [])
            EditLocalStoragePagesData("/settings", "settingName", "profile")
        } else {
            logoutAndGoHome();
        }
    }

    const requireAuthNavigate = (path) => {
        if (profile) {
            navigate(path);
            return;
        }
        saveAuthReturnPath(path);
        window.location.href = auth;
        EditLocalStoragePagesData("/settings", "expanded", []);
        EditLocalStoragePagesData("/settings", "settingName", "profile");
    };
    return <Box sx={{display: "flex", flexDirection: "column", minHeight: "100vh"}}>
        <Box
            sx={{
                width: "100%",
                "@media (max-width: 1023px)": {
                    position: "sticky",
                    top: 0,
                    zIndex: (theme) => theme.zIndex.appBar,
                    boxShadow: "none",
                    borderBottom: "1px solid rgba(234, 235, 234, 1)",
                },
            }}
        >
            <ScrollToTop/>
            <ToolbarFirst profile={profile} handleChange={handleChange} requireAuthNavigate={requireAuthNavigate}
                          isUpMe={isUpMeDomain && !isOrgOne}
                          domainName={domainName} accessibility={accessibility} stage={stage}/>
            {profile && (
                <ToolbarSecond
                    profile={profile}
                    requireAuthNavigate={requireAuthNavigate}
                    stage={stage}
                    accessibility={accessibility}
                />
            )}
        </Box>
        <AppRouter stage={stage} setStage={setStage} profile={profile} isUpMe={isUpMeDomain && !isOrgOne}
                   domainName={domainName}/>
    </Box>
}
export default ContainerComponent;
